import React from "react";

const Bot = () => {
  return (
    
    <a target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send?phone=263779050634" className="hover:bg-sky-700 fixed bottom-5 sm:right-8 right-4 z-[999] cursor-pointer text-white text-4xl bg-cyan-600 w-16 h-16 flex items-center justify-center rounded-full animate-bounce">
      <ion-icon name="chatbubble-ellipses"></ion-icon>
    </a>
    
  );
};

export default Bot;
